<form #form="ngForm" autocomplete="off" class="app-grid">
    <mat-form-field class="columns-12 no-helpers no-labels">
        <ui-rich-text [(ngModel)]="defaultWelcomeMessage" height="375px" name="defaultWelcomeMessage"></ui-rich-text>
    </mat-form-field>
</form>
